import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A5568",
      "fill-rule": "evenodd",
      d: "M15.657 15.657A8 8 0 1 1 4.343 4.342a8 8 0 0 1 11.314 11.315m-5.444-7.159q-.387.316-.926.316h-.24q-.415 0-.627.176a.55.55 0 0 0-.211.451q0 .288.176.452.175.158.498.158.07 0 .316-.024a4 4 0 0 1 .364-.023q.667 0 1.042.393.375.386.375 1.072 0 .462-.222.814a1.46 1.46 0 0 1-1.254.71q-.633 0-.984-.393-.346-.399-.65-1.213a.44.44 0 0 0-.2-.229.57.57 0 0 0-.316-.1.77.77 0 0 0-.551.212.72.72 0 0 0-.217.545q0 .263.182.667.187.405.545.786.362.375.92.627.555.252 1.26.252.69 0 1.259-.217.574-.223.99-.61.416-.392.627-.89.217-.498.217-1.032 0-.444-.158-.826a2.1 2.1 0 0 0-.475-.703 3.2 3.2 0 0 0-.768-.562q.476-.399.727-.815.258-.422.258-1.008 0-.444-.176-.832a1.9 1.9 0 0 0-.521-.68 2.4 2.4 0 0 0-.815-.445 3.2 3.2 0 0 0-1.037-.158q-.65 0-1.178.188a2.7 2.7 0 0 0-.884.486 2.4 2.4 0 0 0-.54.644 1.34 1.34 0 0 0-.181.64q0 .315.193.509a.62.62 0 0 0 .434.187.8.8 0 0 0 .351-.07.4.4 0 0 0 .211-.193q.1-.23.217-.487.123-.257.258-.421.134-.165.363-.264.235-.1.592-.1.527 0 .838.328.31.322.31.774 0 .591-.392.908",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }